import http from './http'

export default {
  list: () => http.get('/v2/zones')
}



// WEBPACK FOOTER //
// ./src/services/api/zones.js